import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Row, Form, Modal, Card, Col } from "reactstrap"
import Select from "react-select"
// editor
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"
// assets
import Loader from "pages/Separate/Loader"
import "../../../../assets/css/Sales/Sales.css"
import userImg from "../../../../assets/images/users/avatar-1.jpg"
import axios from "axios"
import swal from "sweetalert"
import moment from "moment"
import configure from "configure"

const Followup = props => {
  const [fixButtons, setFixButtons] = useState(false)
  const [notesSidebar, setNotesSidebar] = useState(false)
  const [editNotesSidebar, setEditNotesSidebar] = useState(false)

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const [allFollowUps, setAllFollowUps] = useState([])

  const [purpose, setPurpose] = useState("")
  const [followdate, setFollowDate] = useState("")
  const [assigns, setAssigns] = useState([])
  const [editpurpose, seteditPurpose] = useState("")
  const [editfollowdate, seteditFollowDate] = useState("")
  const [editassigns, seteditAssigns] = useState([])
  const [followId, setFollowId] = useState("")

  const [assign_option, setAssignOption] = useState([])

  useEffect(() => {
    setAssignOption(
      props.assigned_data.map(obj => ({
        label: obj.name,
        value: obj.id,
      }))
    )
  }, [props.assigned_data])

  // getting all followups
  useEffect(() => {
    const getAllFollowUps = async () => {
      setLoading(true)
      try {
        const formData = new FormData()
        formData.append("opportunity_id", props.company_id)
        formData.append("user_id", localStorage.getItem("auth_id"))

        const response = await axios.post(
          `${configure.nodeApi}/opportunity_followup_data`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )

        setAllFollowUps(response.data.data.opportunity_followup_data)
        // console.log("notes", response.data.data)

        setLoading(false)
      } catch (error) {
        console.log(error)
      }
    }
    getAllFollowUps()
  }, [])

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true)
    } else {
      setFixButtons(false)
    }
  })

  const colourStyles = {
    menuList: styles => ({
      ...styles,
      background: "white",
    }),
    menu: base => ({
      ...base,
      zIndex: 50,
    }),
  }

  const handleAddFollowUp = async e => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("purpose", purpose)
      formData.append("date", followdate)
      formData.append("assign", JSON.stringify(assigns))
      formData.append("opportunity_id", props.company_id)
      formData.append("user_id", localStorage.getItem("auth_id"))

      const response = await axios.post(
        `${configure.nodeApi}/add_opportunity_followup`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )

      setNotesSidebar(false)

      setAllFollowUps(response.data.data)

      setLoading(false)

      swal("Follow Up added successfully!", {
        icon: "success",
      }).then(() => {
        setPurpose("")
        setFollowDate("")
        setAssigns("")
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
      swal("Something went wrong", "", "error")
    }
  }

  const handleEditFollowUp = async e => {
    e.preventDefault()
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("purpose", editpurpose)
      formData.append("date", editfollowdate)
      formData.append("assign", JSON.stringify(editassigns))
      formData.append("follow_id", followId)
      formData.append("opportunity_id", props.company_id)
      formData.append("user_id", localStorage.getItem("auth_id"))

      const response = await axios.post(
        `${configure.nodeApi}/edit_opportunity_followup`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )

      setAllFollowUps(response.data.data.opportunity_followup)
      setEditNotesSidebar(false)

      setLoading(false)

      swal("Follow Up Updated successfully!", {
        icon: "success",
      }).then(() => {
        setPurpose("")
        setFollowDate("")
        setAssigns("")
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
      swal("Something went wrong", "", "error")
    }
  }

  const onDeleteNote = follow_id => {
    swal({
      title: "Are you sure?",
      text: "do you really want to remove this Follow Up",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(willDelete => {
      if (willDelete) {
        const formData = new FormData()

        formData.append("follow_id", follow_id)
        formData.append("opportunity_id", props.company_id)
        formData.append("user_id", localStorage.getItem("auth_id"))

        axios
          .post(`${configure.nodeApi}/delete_opportunity_followup`, formData, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
          .then(response => {
            // console.log("de", response.data)

            if (response.data.data.length > 0) {
              setAllFollowUps(response.data.data)
            }

            swal("Note has been deleted successfully!", {
              icon: "success",
            })
          })
      }
    })
  }

  return (
    <React.Fragment>
      {loading && <Loader />}
      <div className="mb-3">
        <div className="px-3 py-4 bg-white">
          {/* Fixed Buttons */}
          <div
            className={`flex-column fixed-buttons ${
              fixButtons ? "d-flex" : "d-none"
            }`}
          >
            <a
              onClick={() => setNotesSidebar(true)}
              className="btn btn-purple border-radius fix-btn"
            >
              <i className="fas fa-plus me-2"></i>
              <span>Note</span>
            </a>
            <a
              onClick={() => navigate(-1)}
              className="btn btn-red border-radius fix-btn"
            >
              <i className="dripicons-cross me-2 icon-center"></i>
              <span>Cancel</span>
            </a>
          </div>
          <div className="d-flex justify-content-between">
            <h5>Add Follow Up</h5>
            <div className="text-end">
              <a
                onClick={() => setNotesSidebar(true)}
                className="border-radius btn btn-purple"
              >
                <i className="fas fa-plus me-2 icon-size"></i>Add FollowUp
              </a>
              <a
                onClick={() => navigate(-1)}
                className="border-radius btn ms-md-2 btn-red"
              >
                <i className="dripicons-cross me-2 icon-center"></i>CANCEL
              </a>
            </div>
          </div>
          {/* Add Notes Sidebar */}
          <div
            className={`notes-sidebar ${
              notesSidebar ? "show-notes-sidebar" : ""
            }`}
          >
            <Form onSubmit={handleAddFollowUp}>
              <Row className="align-items-center ">
                <div className="col-12 d-flex justify-content-between">
                  <h5>Add New FollowUp</h5>
                  <div className="text-end">
                    <button
                      type="submit"
                      className="btn btn-purple border-radius me-2"
                    >
                      <i className="fas fa-plus me-2"></i>Add FollowUp
                    </button>
                    <a
                      onClick={() => setNotesSidebar(false)}
                      className="border-radius btn ms-md-2 btn-red"
                    >
                      <i className="dripicons-cross me-2 icon-center"></i>CANCEL
                    </a>
                  </div>
                </div>
                <div className="col-md-4 mt-3 notes">
                  <label htmlFor="touch">
                    FollowUp Date <span className="text-danger">*</span>
                  </label>
                  <input
                    required
                    type="date"
                    value={followdate}
                    onChange={e => setFollowDate(e.target.value)}
                    className="form-control border-radius"
                  />
                </div>
                <div className="col-md-4 mt-4">
                  <label htmlFor="">Assigned</label>
                  <Select
                    placeholder="Select"
                    className="basic-multi-select"
                    classNamePrefix="border-radius select"
                    styles={colourStyles}
                    options={assign_option}
                    value={assigns}
                    isMulti
                    onChange={e => setAssigns(e)}
                  />
                </div>

                <div className="col-12 mt-4">
                  <label htmlFor="">Purpose</label>
                  <textarea
                    className="form-control"
                    value={purpose}
                    onChange={e => setPurpose(e.target.value)}
                    placeholder="Enter Purpose"
                    style={{ height: "65px" }}
                  ></textarea>
                </div>
              </Row>
            </Form>
          </div>

          <div className="mt-4">
            <ul className="verti-timeline list-unstyled notes-box">
              {allFollowUps?.map(follow => {
                return (
                  <li key={follow.id} className="event-list position-relative">
                    <div className="event-timeline-dot">
                      <img
                        src={`${configure.imgUrl}${follow.addedby_avatar}`}
                        className="userImg me-3 "
                        alt=""
                      />
                    </div>
                    <div className="d-flex">
                      <div className="flex-grow-1 ms-4 note py-2 rounded ps-3 pr-10">
                        <div className=" d-flex justify-content-between ">
                          <div>
                            <p className="text-muted ">
                              <h6 className="d-inline me-2">
                                By {localStorage.getItem("auth_name")}
                              </h6>{" "}
                              {moment(follow.created_at).format(
                                "DD-MM-YYYY hh:mm:ss"
                              )}
                              <span className="pl-15">
                                {" "}
                                Follow Up at{" "}
                                {moment(follow.datetime).format("DD-MM-YYYY")}
                              </span>
                            </p>
                          </div>
                          <div className="me-4">
                            <a
                              onClick={() => {
                                setFollowId(follow.id)

                                seteditAssigns(JSON.parse(follow.assign_user))
                                seteditFollowDate(follow.datetime)
                                seteditPurpose(follow.description)

                                setEditNotesSidebar(true)
                              }}
                              className="btn btn-sm edit-delete-btn text-success me-2"
                            >
                              <i className="fas fa-edit" title="Edit"></i>
                            </a>
                            <a
                              onClick={() => {
                                onDeleteNote(follow.id)
                              }}
                              className="btn btn-sm edit-delete-btn text-danger"
                            >
                              <i
                                className="fas fa-trash-alt"
                                title="Delete"
                              ></i>
                            </a>
                          </div>
                        </div>
                        <i className="bi bi-triangle-fill note-icon"></i>
                        {follow.description}
                        <p className="my-1">
                          <b>Assigned user</b> :{" "}
                          {JSON.parse(follow.assign_user)?.map(ass => (
                            <span key={ass.value}>{ass.label}, </span>
                          ))}{" "}
                        </p>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div
            className={`notes-sidebar ${
              editNotesSidebar ? "show-notes-sidebar" : ""
            }`}
          >
            <form onSubmit={handleEditFollowUp}>
              <Row className="align-items-center justify-content-between">
                <div className="col-12 d-flex justify-content-between">
                  <h5>Edit Follow Up</h5>
                  <div className="text-end">
                    <button className="btn btn-purple border-radius me-2">
                      <i className="fas fa-edit me-2"></i>Edit FollowUp
                    </button>
                    <a
                      onClick={() => setEditNotesSidebar(false)}
                      className="btn btn-red text-uppercase border-radius"
                    >
                      <i className="dripicons-cross me-1 icon-center"></i>
                      Close
                    </a>
                  </div>
                </div>
                <div className="col-md-4 mt-3 notes">
                  <label htmlFor="touch">
                    FollowUp Date <span className="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    required
                    value={editfollowdate}
                    onChange={e => seteditFollowDate(e.target.value)}
                    className="form-control border-radius"
                  />
                </div>
                <div className="col-md-4 mt-3">
                  <label htmlFor="">Assigned</label>
                  <Select
                    className="basic-multi-select"
                    classNamePrefix="border-radius select"
                    isMulti
                    styles={colourStyles}
                    options={assign_option}
                    value={editassigns}
                    onChange={e => seteditAssigns(e)}
                  />
                </div>
                <div className="col-md-4 mt-3 text-end"></div>
                <div className="col-12 mt-4">
                  <label htmlFor="">Purpose</label>
                  <textarea
                    className="form-control"
                    placeholder="Enter Purpose"
                    value={editpurpose}
                    onChange={e => seteditPurpose(e.target.value)}
                    style={{ height: "65px" }}
                  ></textarea>
                </div>
              </Row>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Followup
